import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M14.46 3.84a.67.67 0 0 0-.314-.407l-3.467-2a.667.667 0 0 0-.913.24L8.206 4.38l-1.56-2.707a.667.667 0 0 0-.913-.24l-3.467 2a.67.67 0 0 0-.313.407.67.67 0 0 0 .066.5l2.667 4.553a3.94 3.94 0 0 0-.48 1.774 4 4 0 1 0 7.56-1.814l2.6-4.506a.67.67 0 0 0 .093-.507m-10.92.413L5.845 2.92l2.147 3.747A3.96 3.96 0 0 0 5.539 7.72zm4.666 9.08a2.667 2.667 0 1 1 0-5.333 2.667 2.667 0 0 1 0 5.333M10.873 7.7a3.9 3.9 0 0 0-1.24-.767l-.654-1.22 1.614-2.793 2.306 1.333z"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })